import {
  BackendExceptionResponse, PagedRequest, PricingAvailabilityUpdateResult, PricingDataListFilter,
  PricingDataSearchResult, PricingTriggersCreationResponse,
} from '../apiTypes';
import api from '../base';
import { mockApplyAvailabilityUpdate, mockGetPricingDataList } from '../mocks/pricingDataMocks';
import { XLSX_MIME_TYPE } from '../../services/excel/constants';

export const PRICING_ESHOP_PRODUCTS_IMPORT_PATH = 'management/pricing/eshop-products/import';
const PRICING_DATA_LIST_SEARCH_PATH = '/management/pricing/pricing-data/search';
const PRICING_DATA_AVAILABILITY_UPDATE_EXPORT_PATH = '/management/pricing/pricing-data/availability-export';
const PRICING_DATA_AVAILABILITY_APPLY_PATH = '/management/pricing/pricing-data/availability-apply';
const PRICING_DATA_EXPORT_PATH = '/management/pricing/pricing-data/export';
const PRICING_DATA_PRICING_TRIGGERS_PATH = '/management/pricing/pricing-data/pricing-triggers';

export function mapToSnapshotRequest(
  filter: PricingDataListFilter,
  maxPricingRequestId?: number,
): PricingDataListFilter {
  return { ...filter, maxPricingRequestId };
}

export async function getPricingDataList(
  request: PagedRequest<PricingDataListFilter>,
  signal?: AbortSignal,
) {
  return api.post<PricingDataSearchResult>(PRICING_DATA_LIST_SEARCH_PATH, request, { signal });
}

api.mock.onPost(PRICING_DATA_LIST_SEARCH_PATH).reply(200, mockGetPricingDataList);

export async function applyAvailabilityUpdate(
  request: PricingDataListFilter,
) {
  return api.post<PricingAvailabilityUpdateResult>(PRICING_DATA_AVAILABILITY_APPLY_PATH, request);
}

api.mock.onPost(PRICING_DATA_AVAILABILITY_APPLY_PATH).reply(200, mockApplyAvailabilityUpdate);

export async function exportAvailabilityUpdate(
  request: PricingDataListFilter,
) {
  return api.post<string | BackendExceptionResponse>(
    PRICING_DATA_AVAILABILITY_UPDATE_EXPORT_PATH,
    request,
  );
}

api.mock.onPost(PRICING_DATA_AVAILABILITY_UPDATE_EXPORT_PATH).reply(200, '');

export async function createPricingTriggers(
  request: PricingDataListFilter,
) {
  return api.post<PricingTriggersCreationResponse>(PRICING_DATA_PRICING_TRIGGERS_PATH, request);
}

api.mock.onPost(PRICING_DATA_PRICING_TRIGGERS_PATH).reply(200, { submittedCount: 5 });

export async function exportPricingData(
  request: PricingDataListFilter,
  signal?: AbortSignal,
): Promise<Blob> {
  const response = await api.post<Blob>(PRICING_DATA_EXPORT_PATH, request, {
    responseType: 'blob',
    signal,
  });

  return response.data;
}

api.mock
  .onPost(PRICING_DATA_EXPORT_PATH)
  .reply(200, new Blob(), {
    'Content-Type': XLSX_MIME_TYPE,
  });
